import { Component, OnInit, Input, OnDestroy, SimpleChanges } from '@angular/core';
import { Flight, BookedTrip } from '@ibe/models';
import { getBrandFeatures } from '@ibe/models/ui';
import * as fromStore from '@ibe/store/index';

import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { takeWhile } from 'rxjs/operators';
import { getCurrencySymbol } from '@angular/common';

import {
	BASIC_ANCILLARY_CODES_CHECKED_BAGGAGE,
	TRANSLATION_ANCILLARY_DETAILED,
	BRAND_NAMES_MAP,
	ANCILLARY_PRODUCT_GROUP_CODE_MILES,
	ANCILLARY_PRODUCT_GROUP_CODE_HOLD_BAGGAGE,
	ANCILLARY_PRODUCT_GROUP_CODE_HAND_BAGGAGE,
	ANCILLARY_PRODUCT_GROUP_CODE_SEAT_RESERVATION,
	BASIC_ANCILLARY_CODES_MILES,
	BASIC_ANCILLARY_CODES_HAND_BAGGAGE,
	PAX_TYPE_INFANT_CODE,
	CHECKED_BAGGAGE_FOR_INFANT_TRANSLATION_KEY,
	BASIC_ANCILLARY_CODES_FLIGHT_CHANGES,
	BASIC_ANCILLARY_CODES_FLIGHT_REFUNDS,
	BASIC_ANCILLARY_CODES_SEAT_RESERVATION,
	BRAND_CODE_DISCOUNT,
	BASIC_ANCILLARY_CODES_MEALS,
	BASIC_ANCILLARY_CODES_SNACK,
	SSR_CODE_MEAL_MEALS_AND_BEVERAGES,
	COMMERCIAL_ECONOMY_BRANDS,
	BRAND_CODE_AWARD_ECONOMY,
	BRAND_CODE_STAR_ALLIANCE_ECONOMY,
	FLIGHT_HAUL_TYPE_LONG,
	FLIGHT_HAUL_TYPE_DOMESTIC,
	FLIGHT_HAUL_TYPE_SHORT,
	FLIGHT_HAUL_TYPE_MEDIUM,
	ANCILLARY_PRODUCT_MEAL,
	BRAND_CODE_EXECUTIVE,
	BRAND_CODE_TOP_EXECUTIVE,
	BRAND_CODE_AWARD_EXECUTIVE,
	BRAND_CODE_PLUS,
	ANCILLARY_PRODUCT_GROUP_CODE_MEAL,
	BASIC_ANCILLARY_CODES_PREMIUM_CHECKIN,
	BASIC_ANCILLARY_CODES_FASTTRACK,
	BASIC_ANCILLARY_CODES_LOUNGE,
	BASIC_ANCILLARY_CODES_PREMIUM_BOARDING,
	BASIC_ANCILLARY_CODES_PRIORITY_BAGGAGE
} from '@ibe.config';

import { INDRA_getCheckedBaggageDetails } from '@ibe.components/booking/flights/brand/brand.indra';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { Router } from '@angular/router';

@Component({
	selector: 'app-included-per-passenger',
	templateUrl: './included-per-passenger.indra.component.html',
	styleUrls: ['./included-per-passenger.component.scss']
})
export class INDRAIncludedPerPassengerComponent implements OnInit, OnDestroy {

	@Input() flight: Flight;
	@Input() brand: string;
	@Input() feature: any;
	@Input() passengers: any;
	@Input() personalItem: string = '';
	@Input() mealSegmentsData: any;

	isAlive: boolean;
	inclusionLabels: any[];
	currency;
	mealSegDetails: any = [];
	reviewFlights: boolean = false;


	constructor(
		private store: Store<fromStore.State>,
		private currencyService: INDRACurrencyService,
		private ibeAdminService: INDRAIbeAdminService,
		protected router: Router
	) {
		if (this.router.url.includes('/review-your-trip')) this.reviewFlights = true;
		this.isAlive = true;
	}

	ngOnInit() {
		this.currency = this.feature.currency ? this.currencyService.INDRA_getCurrencySymbol(this.feature.currency).unit : '';
		this.inclusionLabels = this.INDRA_setLabels(this.feature, this.passengers, this.personalItem);
		this.INDRA_setMealSegmentsDetails();
	}

	ngOnDestroy() {
		this.isAlive = false;
	}

	public INDRA_setMealSegmentsDetails() {
		if (this.reviewFlights) {
			if (this.mealSegmentsData && this.mealSegmentsData.length > 0) {
				this.mealSegmentsData.map(data => {
					this.mealSegDetails.push(data.departureAirport + '-' + data.arrivalAirport);
				});
			}
		} else {
			const segmentsWithMeal = JSON.parse(sessionStorage.getItem('ancMealLabelSegments'));
			if (segmentsWithMeal && segmentsWithMeal.length) {
				this.mealSegDetails = segmentsWithMeal.map(segment => segment.route);
			}
		}
	}

	INDRA_setLabels(feature, passengers, personalItem) {
		const brandName = BRAND_NAMES_MAP[this.brand];
		const inclusionLabels = [];
		passengers.forEach(passenger => {
			let includedAncillaryPerPassengerLabel = '';
			if ((feature.code === ANCILLARY_PRODUCT_GROUP_CODE_MILES || feature.code === BASIC_ANCILLARY_CODES_MILES)
				&& feature.type == 'added') {
				// special case: MILES is a different scenario since it has no includedAncillaries
				// and the total miles is returned via the feature descriptionlearn more
				includedAncillaryPerPassengerLabel = this.feature.description;
			}
			else if ((feature.code === ANCILLARY_PRODUCT_GROUP_CODE_HOLD_BAGGAGE || feature.code === BASIC_ANCILLARY_CODES_CHECKED_BAGGAGE)
				&& feature.type == 'added' && passenger.type === PAX_TYPE_INFANT_CODE) {
				// special case: Checked Baggage display handling for infant (different translation)
				includedAncillaryPerPassengerLabel =
					this.INDRA_getTranslation(`${TRANSLATION_ANCILLARY_DETAILED + CHECKED_BAGGAGE_FOR_INFANT_TRANSLATION_KEY}`);
			} else {
				// all other ancillaries
				if (feature.type == 'added') {
					feature.includedAncillaries.forEach(includedAncillary => {
						if (includedAncillary === SSR_CODE_MEAL_MEALS_AND_BEVERAGES) {
							includedAncillaryPerPassengerLabel =
								this.INDRA_setIncludedTextForMealsAncillary(includedAncillary, includedAncillaryPerPassengerLabel, this.brand, this.flight);
						} else {
							if (includedAncillaryPerPassengerLabel.length === 0) {
								includedAncillaryPerPassengerLabel =
									this.INDRA_getTranslation(`${TRANSLATION_ANCILLARY_DETAILED + includedAncillary}`);
							} else {
								includedAncillaryPerPassengerLabel = includedAncillaryPerPassengerLabel + ', '
									+ this.INDRA_getTranslation(`${TRANSLATION_ANCILLARY_DETAILED + includedAncillary}`);
							}
						}
					});

					// there should be no meals for infants if Discount
					if (passenger.type === PAX_TYPE_INFANT_CODE && this.brand.toLowerCase() === BRAND_CODE_DISCOUNT && feature.code === BASIC_ANCILLARY_CODES_MEALS) {
						includedAncillaryPerPassengerLabel = '';
					}

					// special case: hand baggage needs to add additional text for personal item
					if (personalItem && (feature.code === ANCILLARY_PRODUCT_GROUP_CODE_HAND_BAGGAGE || feature.code === BASIC_ANCILLARY_CODES_HAND_BAGGAGE)) {
						includedAncillaryPerPassengerLabel = includedAncillaryPerPassengerLabel + ' ' +
							this.INDRA_getTranslation('whatsIncludedSidebars.detailsHandLuggage.text.personalItemInclusion');
					}

					// handle added features Free Change and Refund ancillaries
					if (feature.code === BASIC_ANCILLARY_CODES_FLIGHT_CHANGES || feature.code === BASIC_ANCILLARY_CODES_FLIGHT_REFUNDS) {
						includedAncillaryPerPassengerLabel = this.INDRA_getTranslation(feature.labelTranslationKey);
					}

					// special case: seats (if type is added, display free)
					if (feature.code === BASIC_ANCILLARY_CODES_SEAT_RESERVATION || feature.code === ANCILLARY_PRODUCT_GROUP_CODE_SEAT_RESERVATION) {
						if (feature.extra && (feature.id == 'seats' || feature.id == ANCILLARY_PRODUCT_GROUP_CODE_SEAT_RESERVATION)) {
							includedAncillaryPerPassengerLabel = this.INDRA_getTranslation('availability.flightsPage.text.comfortseatreservation');
						} else {
							if (this.brand == BRAND_CODE_EXECUTIVE || this.brand == BRAND_CODE_TOP_EXECUTIVE || this.brand == BRAND_CODE_AWARD_EXECUTIVE) {
								includedAncillaryPerPassengerLabel = this.INDRA_getTranslation('availability.flightsPage.text.freeseatreservationv2');
							} else if (this.brand == BRAND_CODE_PLUS) {
								includedAncillaryPerPassengerLabel = this.INDRA_getTranslation('availability.flightsPage.text.comfortseatreservation');
							} else {
								includedAncillaryPerPassengerLabel = this.INDRA_getTranslation('ancillaries.detailed.PSEAT');
							}

						}
					}
					if (feature.code === BASIC_ANCILLARY_CODES_SNACK) {
						includedAncillaryPerPassengerLabel = this.INDRA_getTranslation(feature.labelTranslationKey);
					}

				} else if (feature.type == 'available') {
					passenger.type === PAX_TYPE_INFANT_CODE && feature.code === BASIC_ANCILLARY_CODES_CHECKED_BAGGAGE ?
						includedAncillaryPerPassengerLabel = this.INDRA_getTranslation('ancillaries.texts.notAvailableInfant') :
						includedAncillaryPerPassengerLabel = this.INDRA_getTranslation('ancillaries.texts.chargeable');
				}
			}

			if (includedAncillaryPerPassengerLabel && includedAncillaryPerPassengerLabel.length > 0 && feature.type == 'added') {
				switch (feature.code) {
					case BASIC_ANCILLARY_CODES_MEALS:
						includedAncillaryPerPassengerLabel = includedAncillaryPerPassengerLabel + ' ' + this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.includedIn.MEALS') + ` ${brandName}`;
						break;
					case BASIC_ANCILLARY_CODES_HAND_BAGGAGE:
						includedAncillaryPerPassengerLabel = includedAncillaryPerPassengerLabel + ' ' + this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.includedIn.HANDBAG') + ` ${brandName}`;
						break;
					case BASIC_ANCILLARY_CODES_MILES:
						includedAncillaryPerPassengerLabel = includedAncillaryPerPassengerLabel + ' ' + this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.includedIn.MILES') + ` ${brandName}`;
						break;
					case BASIC_ANCILLARY_CODES_CHECKED_BAGGAGE:
						includedAncillaryPerPassengerLabel = includedAncillaryPerPassengerLabel + ' ' + this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.includedIn.CHECKEDBAG') + ` ${brandName}`;
						break;
					case BASIC_ANCILLARY_CODES_SEAT_RESERVATION:
						includedAncillaryPerPassengerLabel = includedAncillaryPerPassengerLabel + ' ' + this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.includedIn.SEAT') + ` ${brandName}`;
						break;
					case BASIC_ANCILLARY_CODES_FLIGHT_CHANGES:
						includedAncillaryPerPassengerLabel = includedAncillaryPerPassengerLabel + ' ' + this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.includedIn.CHANGES') + ` ${brandName}`;
						break
					case BASIC_ANCILLARY_CODES_FLIGHT_REFUNDS:
						includedAncillaryPerPassengerLabel = includedAncillaryPerPassengerLabel + ' ' + this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.includedIn.REFUNDS') + ` ${brandName}`;
						break;
					case BASIC_ANCILLARY_CODES_PREMIUM_CHECKIN:
						includedAncillaryPerPassengerLabel = includedAncillaryPerPassengerLabel + ' ' + this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.includedIn.PCHECK') + ` ${brandName}`;
						break;
					case BASIC_ANCILLARY_CODES_FASTTRACK:
						includedAncillaryPerPassengerLabel = includedAncillaryPerPassengerLabel + ' ' + this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.includedIn.FAST') + ` ${brandName}`;
						break;
					case BASIC_ANCILLARY_CODES_LOUNGE:
						includedAncillaryPerPassengerLabel = includedAncillaryPerPassengerLabel + ' ' + this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.includedIn.LOUNGE') + ` ${brandName}`;
						break;
					case BASIC_ANCILLARY_CODES_PREMIUM_BOARDING:
						includedAncillaryPerPassengerLabel = includedAncillaryPerPassengerLabel + ' ' + this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.includedIn.PBOARD') + ` ${brandName}`;
						break;
					case BASIC_ANCILLARY_CODES_PRIORITY_BAGGAGE:
						includedAncillaryPerPassengerLabel = includedAncillaryPerPassengerLabel + ' ' + this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.includedIn.PBAG') + ` ${brandName}`;
						break
					default:
						includedAncillaryPerPassengerLabel = includedAncillaryPerPassengerLabel + ' ' + this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.includedInn') + ` ${brandName}`;	
						break;
				}
			}

			// feature label if feature is not included for passenger or if there are no inclusion label
			if (!passenger.ancillaryStatus || includedAncillaryPerPassengerLabel.length === 0) {

				includedAncillaryPerPassengerLabel = feature.labelTranslationKey ?
					this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.no') + ' ' + this.INDRA_getTranslation(feature.labelTranslationKey) : '';

				// special case: additional text for handbaggage and infant type passengers
				if ((feature.code === ANCILLARY_PRODUCT_GROUP_CODE_HAND_BAGGAGE || feature.code === BASIC_ANCILLARY_CODES_HAND_BAGGAGE) &&
					passenger.type === PAX_TYPE_INFANT_CODE) {
					includedAncillaryPerPassengerLabel = includedAncillaryPerPassengerLabel + ' - ' +
						this.INDRA_getTranslation('whatsIncludedSidebars.detailsHandLuggage.texts.noInclusionForInfant');
				}
			}

			inclusionLabels.push(includedAncillaryPerPassengerLabel);
		});

		return inclusionLabels;
	}

	INDRA_printLabel(index) {
		return this.inclusionLabels[index];
	}

	INDRA_printName(passenger) {
		if (passenger) {
			const key = 'whatsIncludedSidebars.passenger.texts.' + passenger.type;
			const pax = passenger.name.split(" ");
			if (pax.length > 2) {
				return this.INDRA_getTranslation(key) + ' ' + pax[2];
			} else {
				return this.INDRA_getTranslation(key) + ' ' + pax[1];
			}
		} else {
			return this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.defaultAdultName');
		}
	}

	INDRA_getTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}


	/**
	 * Special case to add label 'on the intercontinental flight' for 'MEALS' ancillary code when the brand selected is economy
	 * and the flight has a mixed of intercontinental flight (HAUL_LONG) and short/medium flights (HAUL_DOMESTIC, HAUL_SHORT or HAUL_MEDIUM)
	 */
	INDRA_setIncludedTextForMealsAncillary(includedAncillary: string, includedAncillaryPerPassengerLabel: string, brand: string, flight: Flight) {
		let includedLabel = '';
		if ((COMMERCIAL_ECONOMY_BRANDS.includes(brand) || brand === BRAND_CODE_AWARD_ECONOMY || brand === BRAND_CODE_STAR_ALLIANCE_ECONOMY) &&
			flight.listSegment.length > 1 && flight.listSegment.filter(s => s.haul === FLIGHT_HAUL_TYPE_LONG).length > 0 &&
			flight.listSegment.filter(s => s.haul === FLIGHT_HAUL_TYPE_DOMESTIC || s.haul === FLIGHT_HAUL_TYPE_SHORT || s.haul === FLIGHT_HAUL_TYPE_MEDIUM).length > 0) {

			includedLabel = this.INDRA_getTranslation(`${TRANSLATION_ANCILLARY_DETAILED + includedAncillary}`) + ' ' +
				this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.onIntercontinentalFlight');
		} else {
			includedLabel = this.INDRA_getTranslation(`${TRANSLATION_ANCILLARY_DETAILED + includedAncillary}`);
		}

		if (includedAncillaryPerPassengerLabel.length === 0) {
			includedLabel = includedLabel;
		} else {
			includedLabel = includedAncillaryPerPassengerLabel + ', '
				+ includedLabel;
		}

		return includedLabel;
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes['passengers'] && this.feature && this.passengers && (this.feature.code === BASIC_ANCILLARY_CODES_MEALS || this.feature.code === ANCILLARY_PRODUCT_MEAL)) {
			this.inclusionLabels = this.INDRA_setLabels(this.feature, this.passengers, this.personalItem);
		}
	}
}
